import React from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { FaRocket, FaHammer, FaCog } from "react-icons/fa";

const ComingSoon = ({ onGoBack, categoryName = "Category" }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex flex-col items-center justify-center px-4 py-4">
      {/* Floating background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-5 left-10 w-20 h-20 bg-orange-200 rounded-full opacity-20 animate-pulse"></div>
        <div className="absolute top-40 right-20 w-32 h-32 bg-orange-300 rounded-full opacity-15 animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-orange-400 rounded-full opacity-25 animate-pulse delay-2000"></div>
        <div className="absolute bottom-40 right-10 w-16 h-16 bg-orange-500 rounded-full opacity-20 animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 text-center w-full mx-auto">
        {/* Main Content */}
        <div className="relative">
          {/* Animated Icons */}
          <div className="flex justify-center items-center mb-8 relative">
            <div className="relative">
              <FaRocket className="text-6xl text-orange-500 animate-bounce" />
              <div className="absolute -top-2 -right-2">
                <FaCog className="text-2xl text-orange-300 animate-spin" />
              </div>
              <div className="absolute -bottom-2 -left-2">
                <FaHammer className="text-2xl text-orange-400 animate-pulse" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4">
            <span className="bg-gradient-to-r from-orange-500 to-orange-600 bg-clip-text text-transparent">
              Coming Soon
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-600 mb-6 font-light">
            {categoryName} products are being prepared
          </p>

          {/* Description */}
          <p className="text-gray-500 mb-8 text-lg leading-relaxed">
            We're working hard to bring you the best selection of products.
            <br className="hidden md:block" />
            Our team is curating amazing items just for you!
          </p>

          {/* Progress Bar */}
          <div className="w-full bg-gray-200 rounded-full h-2 mb-8 overflow-hidden">
            <div
              className="bg-gradient-to-r from-orange-400 to-orange-600 h-2 rounded-full animate-pulse"
              style={{ width: "75%" }}
            >
              <div className="h-full bg-white opacity-30 animate-pulse"></div>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-orange-100">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <FaRocket className="text-orange-500 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">Fast Launch</h3>
              <p className="text-gray-600 text-sm">
                Products will be available soon with lightning-fast delivery
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-orange-100">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <FaHammer className="text-orange-500 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">
                Quality Build
              </h3>
              <p className="text-gray-600 text-sm">
                We're ensuring every product meets our high standards
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-orange-100">
              <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <FaCog className="text-orange-500 text-xl" />
              </div>
              <h3 className="font-semibold text-gray-800 mb-2">
                Perfect Setup
              </h3>
              <p className="text-gray-600 text-sm">
                Fine-tuning the experience for seamless shopping
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="mt-12">
            <button
              onClick={onGoBack}
              className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-3 rounded-full font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              Explore Other Categories
            </button>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-orange-100 to-transparent pointer-events-none"></div>

      {/* Animated particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-orange-300 rounded-full opacity-30 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default ComingSoon;
